<template>
  <pageHeader :pageName="this.$store.getters.getWordLocale('txt_bulunamadi')" />
  <div>
    <div class="container page-404-area">
      <div
        class="d-flex justify-content-center align-items-center -error-title"
      >
        <span>{{this.$store.getters.getWordLocale("txt_sayfalara_goz_atabilirsiniz")}}</span>
      </div>

      <div class="row flex-wrap error-description-box">
        <div class="col-xl-3 col-lg-3 col-md col-sm col">
          <div class="card-item">
            <i class="material-icons-outlined">home </i>
            <span> {{ this.$store.getters.getWordLocale("txt_anasayfa") }} </span>
            <a :href="'/' + this.$store.state.langCodeX">{{
              this.$store.getters.getWordLocale("txt_git")
            }}</a>
          </div>
        </div>
        <div class="col-xl-3 col-lg-3 col-md col-sm col">
          <div class="card-item">
            <i class="material-icons-outlined"> business </i>
            <span>{{ this.$store.getters.getWordLocale("txt_firma_listesi") }}</span>
            <a :href="'/' + this.$store.state.langCodeX + '/companies'">{{
              this.$store.getters.getWordLocale("txt_git")
            }}</a>
          </div>
        </div>
        <div class="col-xl-3 col-lg-3 col-md col-sm col">
          <div class="card-item">
            <i class="material-icons-outlined"> mail </i>
            <span>{{ this.$store.getters.getWordLocale("txt_talep_listesi") }}</span>
            <a :href="'/' + this.$store.state.langCodeX + '/leads'">{{
              this.$store.getters.getWordLocale("txt_git")
            }}</a>
          </div>
        </div>
        <div class="col-xl-3 col-lg-3 col-md col-sm col">
          <div class="card-item">
            <i class="material-icons-outlined"> shopping_cart </i>
            <span>{{ this.$store.getters.getWordLocale("txt_urun_listesi") }}</span>
            <a :href="'/' + this.$store.state.langCodeX + '/products'">{{
              this.$store.getters.getWordLocale("txt_git")
            }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageHeader from "./Components/Thema4PageHeader.vue";
export default {
  components: {
    pageHeader,
  },
};
</script>
<style scoped>
.page-404-area {
  padding: 104px 0;
}
.-error-title > span {
  /* M3/title/large */
font-family: 'DM Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 22px;
  line-height: 28px;
  /* identical to box height, or 127% */
  text-align: center;
  font-feature-settings: "liga" off;
  /* Color/Grey/grey-500 */
  color: var(--m3--sys--light--on-surface);
  margin-bottom: 24px;
}
.error-description-box {
  margin-top: 25px;
}
.error-description-box .card-item i {
  color: var(--m3--sys--light--primary);
  font-size: 40px;
  line-height: 40px;
}
.error-description-box .card-item span {
  /* M3/title/large */
  font-family: 'DM Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 22px;
  line-height: 28px;
  /* identical to box height, or 127% */
  text-align: center;
  font-feature-settings: "liga" off;
  color: var(--m3--sys--light--on-surface-variant);
  margin-top: 24px;
}
.error-description-box .card-item a {
  font-family: 'DM Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */
  text-align: center;
  letter-spacing: 0.5px;
  /* M3/sys/light/primary */
  color: var(--m3--sys--light--primary);
  margin-top: 17px;
}

.error-description-box .card-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px 15px;
  height: 280px;
  /* M3/sys/light/background */
  background: var(--m3--sys--light--background);
  min-width: 250px;
  margin-bottom: 15px;
}
</style>
